// checkinRequestsApi — cola de visitas por aprobar del registro por QR (F1, jul-2026).
// El cliente se registra solo desde su teléfono (QR del mostrador): su ALTA es inmediata,
// pero la VISITA queda pendiente hasta que el negocio la apruebe desde aquí.
// Backend: lealify-base routes/loyalty.js (/checkin-requests*).
import { baseApi } from './baseClient';

export interface CheckinRequest {
  id: number;
  status: 'pending' | 'approved' | 'rejected' | 'expired';
  is_new_contact: 0 | 1;
  created_at: string;
  resolved_at: string | null;
  branch_id: number | null;
  contact_id: number;
  first_name: string;
  last_name: string | null;
  phone: string;
  points_balance: string | number;
  last_visit_at: string | null;
  branch_name: string | null;
  // Carita que eligió el cliente al registrarse por QR (30-oct-2026); null = no calificó. 'omitted' = tocó «Omitir».
  feedback?: 'excelente' | 'bueno' | 'neutral' | 'malo' | 'omitted' | null;
}

export interface ApproveResult {
  ok: boolean;
  id: number;
  points_added?: number;
  balance?: number;
  reason?: string;
  message?: string;
  error?: string;      // mismo texto que /checkin (p. ej. folio duplicado: cuándo y a quién)
  code?: string;
  waitMinutes?: number;
  accrual_blocked?: { reason: string; reason_label?: string } | null;   // «no acumula» (19-oct-2026)
}

export const checkinRequestsApi = {
  list: (status: 'pending' | 'approved' | 'rejected' = 'pending', limit = 50) =>
    baseApi.get<{ requests: CheckinRequest[] }>(`/loyalty/checkin-requests?status=${status}&limit=${limit}`),

  // Solo el número, para el badge del menú (se sondea cada 30s).
  count: () => baseApi.get<{ pending: number; enabled: boolean }>('/loyalty/checkin-requests/count'),

  // amount solo aplica en cashback (los puntos son un % del consumo); en visits se ignora.
  // ticketRef: folio del ticket (23-oct-2026), solo si el negocio tiene el folio en 'optional' o 'required'.
  approve: (id: number, amount = 0, ticketRef?: string) =>
    baseApi.post<ApproveResult>(`/loyalty/checkin-requests/${id}/approve`,
      ticketRef ? { amount, ticket_ref: ticketRef } : { amount }),

  // ticketRefs: { <id solicitud>: folio }. Con 'required' el servidor rechaza el lote entero (400
  // TICKET_REF_REQUIRED + `missing`) si a alguna pendiente le falta.
  approveAll: (ticketRefs?: Record<number, string>) =>
    baseApi.post<{ approved: number; failed: ApproveResult[]; total: number }>(
      '/loyalty/checkin-requests/approve-all', ticketRefs ? { ticket_refs: ticketRefs } : {}),

  reject: (id: number) =>
    baseApi.post<{ ok: boolean }>(`/loyalty/checkin-requests/${id}/reject`, {}),
};
